import type { SVGProps } from 'react';

export const VisibilityHidden = (props: SVGProps<any>) => (
  <svg
    role="img"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'visibility hidden'}</title>
    <path
      d="M99.34,49.6a58.27,58.27,0,0,0-17.1-19.44L98.43,18.6l-3-4.25L77.52,27.11A53.84,53.84,0,0,0,52.38,20c-.61,0-1.24-.06-1.86-.06H50C15.64,19.9,1.24,48.39.65,49.6L.09,50.74l.55,1.15a57.18,57.18,0,0,0,16,18.69L1.48,81.4l3,4.25L21.22,73.72A54.35,54.35,0,0,0,50,81.59h.53c.63,0,1.26,0,1.88-.07,32.11-1.3,46.32-28.4,46.92-29.58l.59-1.17ZM50.27,25.13c.58,0,1.16,0,1.73,0a25.54,25.54,0,0,1,17.1,8l-8.31,5.93L59.51,40A13.49,13.49,0,0,0,38.09,55.26L31.48,60l-3.66,2.61A25.59,25.59,0,0,1,50.27,25.13ZM6,50.77A54.53,54.53,0,0,1,27.23,30.56a30.77,30.77,0,0,0-3.7,35.09l-2.12,1.52-.3.21A52.82,52.82,0,0,1,6,50.77ZM25.9,70.38l.54-.39c.33.41.66.8,1,1.19C26.92,70.92,26.41,70.65,25.9,70.38ZM52,76.32l-1.75,0A25.58,25.58,0,0,1,30.7,67L41,59.58A13.47,13.47,0,0,0,62.65,44.15l9.64-6.88A25.61,25.61,0,0,1,52,76.32ZM74.7,69.84a30.7,30.7,0,0,0,1.84-35.61l1.08-.77.1-.07A53.93,53.93,0,0,1,94,50.73,55.31,55.31,0,0,1,74.7,69.84Z"
      fill={props.fill}
    />
  </svg>
);
